import { InputBase } from "@material-ui/core";
import * as React from "react";
import QuiqButton, { ButtonProps } from "./QuiqButton";
import "./TextInputWithButton.scss";

interface TextInputProps {
  id?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  buttonText?: string;
  buttonProps?: InputComponentButtonProps;
  value?: string;
  isLoading?: boolean;
  onKeyUp?: (event: any) => void;
  type?: string;
  autoFocus?: boolean;
}

const TextInputWithButton: React.SFC<TextInputProps> = (
  props: TextInputProps
) => (
  <div className="InputComponent">
    <div className="InputWrapper">
      <InputBase
        autoFocus={props.autoFocus}
        placeholder={props.placeholder}
        id={props.id}
        className={`InputBase ${props.className}`}
        classes={{
          focused: "InputBase--focused"
        }}
        inputProps={{
          onChange: props.onChange,
          value: props.value,
          maxLength: 5000
        }}
        disabled={props.isLoading}
        onKeyUp={props.onKeyUp}
        type={props.type || "text"}
      />
      {props.buttonProps && !props.buttonProps.hideButton && (
        <QuiqButton
          {...props.buttonProps.quiqButtonProps}
          className={`InputButton ${
            props.value && props.value !== "" ? "QuiqButton--show" : ""
          }`}
          isLoading={props.isLoading}
        >
          {props.buttonProps.buttonText}
        </QuiqButton>
      )}
    </div>
  </div>
);

interface InputComponentButtonProps {
  buttonText?: string;
  quiqButtonProps?: ButtonProps;
  hideButton?: boolean;
}

export default TextInputWithButton;



// WEBPACK FOOTER //
// ./src/shared/TextInputWithButton.tsx